module.exports = __webpack_public_path__ + "img/asistentes-white.755b034c.svg";